export default __webpack_public_path__ + "static/media/BMJ.552da759.png";